import { z } from 'zod';
import { idInput, paginationInput } from './common';

// Enums
export const checklistItemTipoEnum = z.enum(['CHECKBOX', 'STATUS', 'TEXTO', 'NUMERO', 'FOTO']);

// Item config schema - nullish() allows both null and undefined
export const checklistItemConfigSchema = z.object({
  options: z.array(z.string()).optional(),
  min: z.number().optional(),
  max: z.number().optional(),
  unit: z.string().optional(),
  maxLength: z.number().optional(),
  multiline: z.boolean().optional(),
  maxPhotos: z.number().optional(),
  placeholder: z.string().optional(),
}).nullish();

// Item schema for form builder
export const checklistItemSchema = z.object({
  id: z.string().uuid().optional(),
  nome: z.string().min(1, 'Nome e obrigatorio'),
  descricao: z.string().optional(),
  tipo: checklistItemTipoEnum,
  config: checklistItemConfigSchema,
  obrigatorio: z.boolean().default(false),
  ordem: z.number().int().min(0).default(0),
  dataPrazo: z.string().nullish(),
});

// Section schema for form builder
export const checklistSecaoSchema = z.object({
  id: z.string().uuid().optional(),
  nome: z.string().min(1, 'Nome da secao e obrigatorio'),
  ordem: z.number().int().min(0).default(0),
  itens: z.array(checklistItemSchema).default([]),
});

// List input
export const listChecklistsInput = paginationInput.extend({
  comissaoId: z.string().uuid().optional(),
  eventoId: z.string().uuid().optional(),
  campanhaId: z.string().uuid().optional(),
});

// Save full checklist input (create/update with nested structure)
export const saveChecklistInput = z.object({
  id: z.string().uuid().optional(),
  comissaoId: z.string().uuid(),
  nome: z.string().min(3, 'Nome deve ter no minimo 3 caracteres'),
  descricao: z.string().optional(),
  secoes: z.array(checklistSecaoSchema).default([]),
});

// Delete input
export const deleteChecklistInput = idInput;

// Response value schema
export const checklistRespostaValorSchema = z.object({
  valor: z.union([z.boolean(), z.string(), z.number(), z.array(z.string()), z.null()]),
  observacao: z.string().optional(),
});

// Get response input
export const getRespostaInput = z.object({
  checklistId: z.string().uuid(),
  comissaoMembroId: z.string().uuid(),
});

// Save response input
export const saveRespostaInput = z.object({
  checklistId: z.string().uuid(),
  comissaoMembroId: z.string().uuid(),
  valores: z.record(z.string().uuid(), checklistRespostaValorSchema),
});

// Complete response input
export const completeRespostaInput = idInput;

// Types
export type ChecklistItemTipo = z.infer<typeof checklistItemTipoEnum>;
export type ChecklistItemConfig = z.infer<typeof checklistItemConfigSchema>;
export type ChecklistItemSchema = z.infer<typeof checklistItemSchema>;
export type ChecklistSecaoSchema = z.infer<typeof checklistSecaoSchema>;
export type ListChecklistsInput = z.infer<typeof listChecklistsInput>;
export type SaveChecklistInput = z.infer<typeof saveChecklistInput>;
export type DeleteChecklistInput = z.infer<typeof deleteChecklistInput>;
export type ChecklistRespostaValor = z.infer<typeof checklistRespostaValorSchema>;
export type GetRespostaInput = z.infer<typeof getRespostaInput>;
export type SaveRespostaInput = z.infer<typeof saveRespostaInput>;
export type CompleteRespostaInput = z.infer<typeof completeRespostaInput>;
